<div class="form-list">
  <header class="list-header">
    <h1>{{ 'admin.forms.title' | localize }}</h1>
    <a routerLink="/admin/forms/new" class="btn-create">{{ 'admin.forms.createNew' | localize }}</a>
  </header>

  @if (loading) {
    <div class="loading">{{ 'admin.forms.loading' | localize }}</div>
  } @else if (error) {
    <div class="error">{{ error }}</div>
  } @else if (forms.length === 0) {
    <div class="empty">
      <p>{{ 'admin.forms.empty.title' | localize }}</p>
      <a routerLink="/admin/forms/new">{{ 'admin.forms.empty.action' | localize }}</a>
    </div>
  } @else {
    <table class="forms-table">
      <thead>
        <tr>
          <th>{{ 'admin.forms.table.formId' | localize }}</th>
          <th>{{ 'admin.forms.table.title' | localize }}</th>
          <th>{{ 'admin.forms.table.version' | localize }}</th>
          <th>{{ 'admin.forms.insuranceCompany' | localize }}</th>
          <th>{{ 'admin.forms.natCatType' | localize }}</th>
          <th>{{ 'admin.forms.natCatName' | localize }}</th>
          <th>{{ 'admin.forms.table.status' | localize }}</th>
          <th>{{ 'admin.forms.table.actions' | localize }}</th>
        </tr>
      </thead>
      <tbody>
        @for (form of forms; track form.formId) {
          <tr>
            <td>{{ form.formId }}</td>
            <td>{{ form.title }}</td>
            <td>{{ form.version }}</td>
            <td>{{ form.metadata?.insuranceCompany || '-' }}</td>
            <td>{{ form.metadata?.natCatType || '-' }}</td>
            <td>{{ form.metadata?.natCatName || '-' }}</td>
            <td>
              <span class="status-badge" [class]="'status-' + form.status">
                {{ form.status }}
              </span>
            </td>
            <td>
              <div class="buttons are-small">
                <a [routerLink]="['/admin/forms/edit', form.formId, form.version]" class="button is-small is-info is-outlined">
                  {{ 'admin.forms.table.edit' | localize }}
                </a>
                <a [routerLink]="['/admin/forwarding/forms', form.formId, 'versions', form.version]" class="button is-small is-info is-outlined">
                  {{ 'admin.forms.table.forwarding' | localize }}
                </a>
              </div>
            </td>
          </tr>
        }
      </tbody>
    </table>
  }
</div>
